export type OrderableColumn = {
  key: string;
  stickTo?: 'left' | 'right' | 'none';
};

const isPinned = (column: OrderableColumn) =>
  column.stickTo === 'left' || column.stickTo === 'right';

export function applyColumnOrder<T extends OrderableColumn>(
  defaultColumns: T[],
  savedOrder: string[] | null | undefined
): T[] {
  if (!savedOrder || savedOrder.length === 0) return defaultColumns;

  const unpinned = defaultColumns.filter((column) => !isPinned(column));
  const byKey = new Map(unpinned.map((column) => [column.key, column]));

  const reordered = savedOrder
    .map((key) => byKey.get(key))
    .filter((column): column is T => column !== undefined);
  const placedKeys = new Set(reordered.map((column) => column.key));
  reordered.push(...unpinned.filter((column) => !placedKeys.has(column.key)));

  let nextUnpinnedIndex = 0;
  return defaultColumns.map((column) =>
    isPinned(column) ? column : reordered[nextUnpinnedIndex++]
  );
}
